import React, { lazy, Suspense } from 'react'
import { getQuery } from '@sw/utils/lib/query'
import { ErrorBoundary } from 'react-error-boundary'
// import { getToken } from '@utils'
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom'
import SWRConfig from '@sw/utils/lib/swr'
import Loading from '@components/loading/normal'
import { ErrorPage } from './components/DingLoading'

// import { dygcDomain } from '@utils/constants'
import '@styles/tailwind.css'
import '@styles/tailwind.form.css'
import '@styles/scrollbar.css'
import '@styles/font.css'
import 'reactjs-popup/dist/index.css'
import 'react-tabs/style/react-tabs.css'
import 'rc-tree/assets/index.css'
import 'rc-drawer/assets/index.css'

const Debug = lazy(() => import('./debug/plugin'))
function App() {
  console.log('[进入小程序时间]：', Date.parse(new Date()))
  const { debug } = getQuery()
  const ErrorFallback = ({ error }) => {
    return (
      <div role="alert">
        <ErrorPage txt="页面走丢了，请刷新重试" error={error.message} />
      </div>
    )
  }
  return (
    <div className="App font-hei h-screen">
      <ErrorBoundary FallbackComponent={ErrorFallback}>
        {/* {!token && '未登录'} */}
        <Suspense fallback={<Loading />}>
          <SWRConfig>
            <Router>
              <Switch>
                {/* 大气 */}
                <Route
                  path="/apps/:appId"
                  component={lazy(() => import('@pages-app/layouts/main'))}
                />
                {/* 精细化 */}
                <Route
                  path="/refinement/apps/:appId"
                  component={lazy(() =>
                    import('@pages-refinement/layouts/main')
                  )}
                />
                {/* <Route
                path="/apps/:appId/res/2/level"
                exact
                component={lazy(() => import('@pages-app/inspected/level'))}
              /> */}
                <Route
                  path="/map"
                  exact
                  component={lazy(() => import('@pages-map/index'))}
                />
                <Route
                  path="/muck"
                  component={lazy(() => import('@pages-muck/main'))}
                />
                <Route
                  path="/debug"
                  component={lazy(() => import('./debug/index'))}
                />
                <Route
                  path="/jrjb/home"
                  component={lazy(() => import('./jrjb/index'))}
                />
                {/* <Route
                path="/home"
                exact
                component={lazy(() => import('@pages-statistics/common/home/index'))}
              />
              <Route
                path="/rank"
                exact
                component={lazy(() => import('@pages-statistics/common/rank/index'))}
              />
              <Route
                path="/cockpit"
                exact
                component={lazy(() => import('@pages-statistics/common/cockpit/index'))}
              /> */}
              </Switch>
            </Router>
          </SWRConfig>
          {debug && <Debug />}
        </Suspense>
      </ErrorBoundary>
    </div>
  )
}

export default App
